import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';
import SplitText from 'gsap/SplitText';
// import Lenis from '@studio-freight/lenis';
import SplitType from 'split-type';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);



// // Expose GSAP et ScrollTrigger à la console si besoin
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

//
// ============================================
// 1. Effet Parallax horizontal sur .surtitre-gsap
// ============================================
// S'applique uniquement à partir de 768px de large
//
ScrollTrigger.matchMedia({
    "(min-width: 768px)": function () {
        gsap.utils.toArray('.surtitre-gsap').forEach((el) => {
            const container = el.closest('.years'); // Adapter au parent réel
            if (!container) return;

            const distance = el.getBoundingClientRect().left - container.getBoundingClientRect().left;

            gsap.fromTo(
                el,
                { x: 0 },
                {
                    x: -distance,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: container,
                        start: 'top 90%',
                        end: 'top 10%',
                        scrub: true
                    }
                }
            );
        });
    }
});

// ============================================
// 2. Scroll Effects sur .pdw-section-slider
// ============================================
document.addEventListener('DOMContentLoaded', () => {

    // Détection Safari
    function isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    // Appliqués uniquement à partir de 768px de large
    ScrollTrigger.matchMedia({
        "(min-width: 768px)": function () {
            const sliderSection = document.querySelector('.pdw-section-slider');
            const content = sliderSection?.querySelector('.slider-content-wrapper');
            const image = sliderSection?.querySelector('.slider-image');

            if (!sliderSection || !content || !image) return;

            // === 2.1 Overlay sombre progressif ===
            ScrollTrigger.create({
                trigger: sliderSection,
                start: 'top+=100 top',
                end: 'top+=700 top',
                scrub: true,
                onUpdate: (self) => {
                    const progress = self.progress.toFixed(2);
                    sliderSection.style.setProperty('--overlay-opacity', progress);
                }
            });

            // === 2.1 bis : Scale de l'image d'arrière-plan ===
            gsap.to(image, {
                scale: 1.8,
                ease: "none",
                scrollTrigger: {
                    trigger: sliderSection,
                    start: 'top+=0 top',
                    end: 'top+=700 top',
                    scrub: true
                }
            });

            // === 2.2 Parallaxe verticale sur le contenu ===
            gsap.to(content, {
                y: -300,
                ease: "none",
                scrollTrigger: {
                    trigger: sliderSection,
                    start: 'top+=100 top',
                    end: 'top+=700 top',
                    scrub: true
                }
            });



// === 2.3 Parallaxe sur la forme décorative (hors Safari) ===

// Sélectionne la section contenant la forme décorative
            const shapeSection = document.querySelector('.pdw-section-presentation-avec-image');

// Sélectionne la forme décorative à animer
            const shape = document.querySelector('.pdw-shape');

// Vérifie que les deux éléments existent ET que le navigateur n'est pas Safari
            if (shapeSection && shape && !isSafari()) {

                // Détermine l’échelle de la forme selon la largeur de l’écran : plus petite sur mobile
                const scaleValue = window.innerWidth < 768 ? 7 : 7;

                // Lance l’animation avec GSAP
                gsap.to(shape, {
                    // Fait monter la forme de 350px
                    y: -350,

                    // Applique un zoom défini par la variable scaleValue
                    scale: scaleValue,

                    // Rend la forme partiellement transparente
                    opacity: 0.1,

                    // Centre le point d’origine de la transformation (utile pour le scale)
                    transformOrigin: 'center center',

                    // Aucune accélération/décélération : le mouvement est linéaire
                    ease: 'none',

                    // Configuration du ScrollTrigger
                    scrollTrigger: {
                        trigger: shapeSection,        // C’est cette section qui déclenche l’effet
                        start: 'top 90%',             // Débute quand le haut de la section atteint 90% du viewport
                        end: 'top -150%',             // Termine quand le haut de la section a dépassé de 100% le haut du viewport
                        scrub: true                   // Synchronise l’animation au scroll de manière fluide
                   }
                });
            }
        }
    });

});


// Shape autres pages

// === 2.3 Parallaxe sur la forme décorative ===
// Détecte Safari
function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

// Parallaxe uniquement si écran large, section et shape présents, et pas Safari
const shapeSection = document.querySelector('.pdw-section-presentation-avec-image');
const shape = document.querySelector('.pdw-shape-alt');

if (window.innerWidth >= 768 && shapeSection && shape && !isSafari()) {
    gsap.to(shape, {
        y: -350,
        scale: 7,
        opacity: 0.1,
        transformOrigin: 'center center',
        ease: 'none',
        scrollTrigger: {
            trigger: shapeSection,
            start: 'top -1%',
            end: 'top -100%',
            scrub: true
        }
    });
}

// Ideam pour le header

ScrollTrigger.matchMedia({
    "(min-width: 768px)": function () {
        const header = document.querySelector('.page-header.container-hero');
        const image = header?.querySelector('.slider-image');

        if (!header || !image) return;

        gsap.to(image, {
            scale: 1.8,
            ease: "none",
            scrollTrigger: {
                trigger: header,
                start: 'top top',
                end: 'top+=700 top',
                scrub: true
            }
        });
    }
});



//
// ============================================
// 3. Text Reveal avec SplitType (effet typographique)
// ============================================
// .reveal-type → data-bg-color et data-fg-color utilisés comme couleurs dynamiques
//
const splitTypes = document.querySelectorAll('.reveal-type');

splitTypes.forEach((el) => {
    const bg = el.dataset.bgColor || '#000';
    const fg = el.dataset.fgColor || '#fff';

    const split = new SplitType(el, {
        types: 'words chars',
        tagName: 'span'
    });

    // Chaque mot garde sa propre ligne
    el.querySelectorAll('.word').forEach(word => {
        word.style.whiteSpace = 'nowrap';
    });

    gsap.fromTo(
        split.chars,
        { color: bg },
        {
            color: fg,
            duration: 0.3,
            stagger: 0.02,
            scrollTrigger: {
                trigger: el,
                start: 'top 100%',
                end: 'top 30%',
                scrub: true
            }
        }
    );
});

//
// ============================================
// 4. Autre exemple de parallaxe verticale (commenté)
// ============================================
//
// gsap.to('.parallax-image', {
//   y: -600,
//   ease: 'none',
//   scrollTrigger: {
//     trigger: '.pdw-section-presentation-avec-image',
//     start: 'top bottom',
//     end: 'bottom top',
//     scrub: true,
//     // markers: true
//   }
// });



//



// Animation ligne timeline
if (document.querySelector('.vertical-line')) {
    gsap.set('.vertical-line', { '--sy': 0 });

    gsap.utils.toArray('.timeline-row').forEach((row, idx, rows) => {
        const line = row.querySelector('.vertical-line');
        if (!line) return;

        const isLast = (idx === rows.length - 1);

        gsap.to(line, {
            '--sy': 1,
            ease: 'none',
            scrollTrigger: {
                trigger: row,
                start: 'top 80%',
                end: isLast ? 'bottom 80%' : 'bottom 30%',
                scrub: true,
                invalidateOnRefresh: true
            }
        });
    });
}

// Marquee

document.addEventListener("DOMContentLoaded", () => {
    const rail = document.querySelector('.scrolling-text .rail');
    if (!rail) return;

    // Dupliquer le contenu pour effet continu fluide
    const content = rail.innerHTML;
    rail.innerHTML += content;

    const scrollingItems = gsap.utils.toArray('.scrolling-text .rail .marquee-item');
    if (!scrollingItems.length) return;

    // Lancer le scroll horizontal en boucle
    const tl = horizontalLoop(scrollingItems, {
        repeat: -1,
        speed: 1, // tu peux ajuster la vitesse ici
    });

    let speedTween;

    // ScrollTrigger : change la vitesse en fonction du scroll
    ScrollTrigger.create({
        trigger: ".scrolling-text",
        start: "top bottom",
        end: "bottom top",
        onUpdate: (self) => {
            if (speedTween) speedTween.kill();

            speedTween = gsap.timeline()
                .to(tl, {
                    timeScale: 0.5 * self.direction,
                    duration: 0.25
                })
                .to(tl, {
                    timeScale: 1,
                    duration: 1.5
                }, "+=0.5");
        },
        markers: false
    });
});


// Fonction horizontale loop - Marquee On Scroll


function horizontalLoop(items, config) {
    items = gsap.utils.toArray(items);
    config = config || {};
    let tl = gsap.timeline({repeat: config.repeat, paused: config.paused, defaults: {ease: "none"}, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)}),
        length = items.length,
        startX = items[0].offsetLeft,
        times = [],
        widths = [],
        xPercents = [],
        curIndex = 0,
        pixelsPerSecond = (config.speed || 1) * 100,
        snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
        totalWidth, curX, distanceToStart, distanceToLoop, item, i;
    gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
        xPercent: (i, el) => {
            let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
            xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
            return xPercents[i];
        }
    });
    gsap.set(items, {x: 0});
    totalWidth = items[length-1].offsetLeft + xPercents[length-1] / 100 * widths[length-1] - startX + items[length-1].offsetWidth * gsap.getProperty(items[length-1], "scaleX") + (parseFloat(config.paddingRight) || 0);
    for (i = 0; i < length; i++) {
        item = items[i];
        curX = xPercents[i] / 100 * widths[i];
        distanceToStart = item.offsetLeft + curX - startX;
        distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
        tl.to(item, {xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
            .fromTo(item, {xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)}, {xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
            .add("label" + i, distanceToStart / pixelsPerSecond);
        times[i] = distanceToStart / pixelsPerSecond;
    }
    function toIndex(index, vars) {
        vars = vars || {};
        (Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
        let newIndex = gsap.utils.wrap(0, length, index),
            time = times[newIndex];
        if (time > tl.time() !== index > curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
            vars.modifiers = {time: gsap.utils.wrap(0, tl.duration())};
            time += tl.duration() * (index > curIndex ? 1 : -1);
        }
        curIndex = newIndex;
        vars.overwrite = true;
        return tl.tweenTo(time, vars);
    }
    tl.next = vars => toIndex(curIndex+1, vars);
    tl.previous = vars => toIndex(curIndex-1, vars);
    tl.current = () => curIndex;
    tl.toIndex = (index, vars) => toIndex(index, vars);
    tl.times = times;
    tl.progress(1, true).progress(0, true); // pre-render for performance
    if (config.reversed) {
        tl.vars.onReverseComplete();
        tl.reverse();
    }
    return tl;
}

